export const faqData = [
  {
    question: "What kind of community is it? ",
    answer: "This is a community of professionals, Entrepreneurs, Business Owners and Freelancers finding benefits by increasing connections & exchanging projects."
  },
  {
    question: "Is it good for me to join it?",
    answer: "You should join if you are a client, a coach or a freelancer."
  },
  {
    question: "Why is this community good for clients?",
    answer: `They can get their projects done by experts at the client portal.
They can get business growth advice through our consultation.
They can also hire freelancers directly.`
  },
  {
    question: "Why is this community good for freelancers?",
    answer: "They can list their profile on the hiring page and find opportunities for jobs & projects."
  },
  {
    question: "Why is this community good for coaches?",
    answer: "They can offer live courses or training programs. This platform helps them to boost their sales."
  },
  {
    question: "How do I get started?",
    answer: `Click on the 𝐉𝐨𝐢𝐧 𝐂𝐨𝐦𝐦𝐮𝐧𝐢𝐭𝐲 button on the top bar of the website. Join as a client, freelancer or coach.`
  },
  {
    question: "Do you charge any fee for joining?",
    answer: "No, we don't charge any fee until you find any appreciable benefit."
  },
  {
    question: "What do you provide to learners & newbies?",
    answer: "We provide courses to newbies. They can also find free support from senior members in the Whatsapp group."
  }
];

export const teamMembers = [
  // {
  //   id: 1,
  //   name: 'Zeeshan Talat',
  //   role: 'Tax Consultant',
  //   image: require('../src/assets/images/team.jpg'),
  // },
  // {
  //   id: 2,
  //   name: 'Zia Ullah',
  //   role: 'Business Management Expert',
  //   image: require('../src/assets/images/team1.jpg'),
  // },
  // {
  //   id: 3,
  //   name: 'Osama Rajpoot',
  //   role: 'Web Developer',
  //   image: require('../src/assets/images/team2.jpg'),
  // },
  {
    id: 4,
    name: 'Hussain Shah',
    role: 'Software Developer',
    image: require('../src/assets/images/team5.jpg'),
  },
  {
    id: 5,
    name: 'Abdul Rehman',
    role: 'Project Management Expert',
    image: require('../src/assets/images/team6.jpg'),
  },
  {
    id: 6,
    name: 'Awais Saeed',
    role: 'Shopify Expert',
    image: require('../src/assets/images/team7.jpg'),
  }
];

export const clientsRatingData = [
  {
    name: "Muhammad Rehan",
    color: "red",
    rating: 5,
    image: require("../src/assets/images/clients/p1.png"),
    feedback:
      "AS-Tech Community is an incredibly supportive and versatile WhatsApp group dedicated to helping members across various situations and fields. Whether you need technical assistance, professional advice, or just a bit of encouragement, AS-Tech Community is the place to turn to. The members are knowledgeable, friendly, and always willing to lend a hand. The group's collaborative atmosphere ensures that you never feel alone in solving problems or navigating challenges. Highly recommended for anyone looking for a reliable and responsive community!",
  },
  {
    name: "Zia Ullah Khan",
    color: "blue",
    rating: 5,
    image: require("../src/assets/images/clients/p2.png"),
    feedback:
      "AS-Tech Community has greatly enhanced my writing skills and freelance career. Anum Shaheen’s dedication and talent inspire excellence, and the supportive environment fosters growth. This community is perfect for beginners, offering valuable opportunities in freelancing and e-business. Highly recommended for anyone looking to start or advance their freelance journey. Thank you, Anum!",
  },
  {
    name: "Aftab Pitafi",
    color: "orange",
    rating: 5,
    image: require("../src/assets/images/clients/p3.png"),
    feedback:
      "AS - Tech Community is a wonderful platform for learning and earning. It provides skillful people for solution of your problems. It provides amazing educational and learning platform for work providers and learners. Highly recommended",
  },
  {
    name: "Qaisar Ali",
    color: "indigo",
    rating: 5,
    image: require("../src/assets/images/clients/p4.png"),
    feedback:
      "I have been a member of this community for several years now, and it has been an invaluable resource for staying up-to-date with the latest trends and developments in the tech world. This community website is a must-visit for anyone interested in technology. It's a well-rounded platform that combines informative content with a supportive community, making it a great place to learn, share, and grow.",
  },
  {
    name: "Anoosh Salman",
    color: "indigo",
    rating: 5,
    image: require("../src/assets/images/clients/p5.png"),
    feedback:
      "AS- community has tremendously helped me polish my skills and made me a better writer. Anum has great talent of using words and she has the power to inspire others through her hardwork and dedication. Her work is her passion and ensuring outstanding quality is her goal.",
  },
  {
    name: "Abdullah Waseem",
    color: "indigo",
    rating: 5,
    image: require("../src/assets/images/clients/p6.png"),
    feedback:
      "I've worked with As tech community several times on different types of designing services. They communicate well, works until I am satisfied and have wide range of design abilities. Great work!",
  },
];
